/**
 * 
 */
export default [
    {
        text: "N° DE REGISTRO",
        value: "id",
    },
    {
        text: "CLIENTE",
        value: ({ sl_customer }) => sl_customer.business_name,
    },
    {
        text: "CLIENTE sucursal",
        value: 'sl_customer_branch_offices_addresses_unique',
        component: {
            type: 'chip-list',
        },
    },
    {
        text: "RESPONSABLE",
        value: ({ g_user }) => g_user.hr_employee.names + " " + g_user.hr_employee.last_name1 + " " + g_user.hr_employee.last_name2,
    },
    {
        text: "SUCURSAL",
        value: ({ pos_cash_desk }) => pos_cash_desk.g_branch_office.name,
    },
    {
        text: "PAGOS",
        value: ({ transformed_payments }) => transformed_payments.length,
        align: "center",
    },
    {
        text: "TOTAL",
        value: "total",
        align: "right",
        format: "currency",
    },
    {
        text: "CREACIÓN",
        value: "created_at",
        align: "right",
        format: "datetime",
    },
    /*{
        text: "FECHA DE MODIFICACIÓN",
        value: "updated_at",
        align: "right",
        format: "datetime",
    },*/
]
